import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-planet',
  templateUrl: './gb-empty-state-planet.component.html',
  styleUrls: ['./gb-empty-state-planet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStatePlanetComponent {}
